import React from 'react';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { AssetToDelete } from './DeleteAssetModal.meta';
import { useDeleteAssetMutation } from '../../api/useDeleteAssetMutation';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';

interface Props {
  clientId: string;
  asset: AssetToDelete;
  onClose(): void;
  onDelete(): void;
}

export const DeleteAssetModal = ({ clientId, asset, onClose, onDelete }: Props) => {
  const {
    mutateAsync: deleteAsset,
    isLoading: isDeletingAsset,
    error: deleteAssetError,
  } = useDeleteAssetMutation({ clientId });

  const handleDeleteAsset = async () => {
    try {
      await deleteAsset({ clientId, assetId: asset.id });

      onDelete();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'other-assets--delete-asset--modal-header' }}
    >
      <ModalHeader as="h2" id="other-assets--delete-asset--modal-header">
        Are you sure you want to delete this asset?
      </ModalHeader>

      {deleteAssetError && (
        <Alert message={deleteAssetError.message} variant="error" mb="16" mx="24" />
      )}

      <ModalBody>Deleting this asset may remove associated goals (college fund, etc.).</ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="error" isLoading={isDeletingAsset} onClick={handleDeleteAsset} ml="8">
          Delete Asset
        </Button>
      </ModalFooter>
    </Modal>
  );
};
